import { RecommenderLogsResponse } from "./Types";

export const processDataForPromoteTable = (
    liveModelsData: LiveModelApiResponse | null,
    selectedItems: RecommenderLogsResponse[]
): {
    models: Model[];
    appletNames: { [key: string]: string };
    appletsInABTesting: { [key: string]: boolean }
} => {
    const appletNames: { [key: string]: string } = {};
    const appletsInABTesting: { [key: string]: boolean } = {};

    if (liveModelsData) {
        Object.entries(liveModelsData).forEach(([key, applet]) => {
            if (typeof applet === 'object') {
                appletNames[key] = applet.name ?? `${key}`;
                appletsInABTesting[key] = applet.ab_testing_enabled ?? false;
            }
        });
    }

    const liveModelsInABTesting: Model[] = [];
    const liveModelIds: string[] = [];

    if (liveModelsData) {
        Object.entries(liveModelsData).forEach(([key, applet]) => {
            if (typeof applet === 'object' && Array.isArray(applet.models)) {
                applet.models.forEach(model => {
                    liveModelsInABTesting.push({
                        name: model.name,
                        liveApplet: key,
                        id: model.id
                    });
                    liveModelIds.push(model.id);
                });
            }
        });
    }

    const nonLiveModels: Model[] = selectedItems
        .filter(item => !liveModelIds.includes(item.model_id))
        .map(item => ({
            name: item.model_name,
            liveApplet: null,
            id: item.model_id
        }));

    const models: Model[] = [...liveModelsInABTesting, ...nonLiveModels];

    return { models, appletNames, appletsInABTesting };
};

export const hasMultipleModels = (payload: AppletPayload): boolean => {
    if (!payload) return false;

    const appletKeys = Object.keys(payload).filter(key => key !== 'env' && key !== 'channel');

    return appletKeys.some(key => {
        const applet = payload[key] as Applet;
        return Array.isArray(applet?.models) && applet.models.length >= 2;
    });
};

export const checkNotGeneratedStatus = (models: RecommenderLogsResponse[]): boolean => {
    const notGeneratedStatuses = ['Not Generated', 'Not_Generated', 'NOT_GENERATED'];

    return models.some(model =>
        notGeneratedStatuses.includes(model.ars_status)
    );
}